import gql from 'graphql-tag'

const GC_GET_PROPOSAL_LIST = gql`
query GetProposalList {
    proposal {
    	id
    	texte
    }
  }
`

export {
	GC_GET_PROPOSAL_LIST
}